import { useState, createContext, useMemo, useCallback } from "react";
import { Dossier, DossierCreationStepType, Referentiel } from "../../../types";

interface DossierCreationFormType {
    step: number;
    referentiel: Referentiel;
    dossier: Dossier;
    cgv: boolean;
}

const initDossier = {
    id: null,
    completionTime: "",
    processingStep: 0,
    createdAt: "",
    assignedAt: "",
    processedAt: "",
    certificationUrl: "",
    contractUrl: "",
    comment: "",
    assignedUser: null,
    assignedValidatorUser: null,
    assignerUser: null,
    creatorUser: null,
    dossierStatus: null,
    establishment: null,
    establishmentStatus: null,
    referenciel: null,
    submittedAt: null,
    commitmentsCompleted: 0,
};

export const DossierCreationContext = createContext<DossierCreationStepType>({
    step: 1,
    referentiel: {
        id: 1,
        name: "",
        code: "",
    },
    dossier: initDossier,
    cgv: false,
    updateDossierCreationForm: (DossierCreationForm: DossierCreationFormType) =>
        null,
});

export const DossierCreationContextProvider = ({ children }: any) => {
    const [DossierCreationForm, setDossierCreationForm] =
        useState<DossierCreationFormType>({
            step: 1,
            referentiel: {
                id: 1,
                name: "",
                code: "",
            },
            dossier: initDossier,
            cgv: false,
        });

    const updateDossierCreationForm = useCallback(
        (dossierCreationForm: any) => {
            setDossierCreationForm(dossierCreationForm);
        },
        []
    );

    const DossierCreationWrapperContext = useMemo(
        () => ({
            ...DossierCreationForm,
            updateDossierCreationForm,
        }),
        [DossierCreationForm, updateDossierCreationForm]
    );

    return (
        <DossierCreationContext.Provider value={DossierCreationWrapperContext}>
            {children}
        </DossierCreationContext.Provider>
    );
};
